import { useEffect } from "react";
import { X } from "lucide-react";

export default function Modal({ open, onClose, title, children, size = "md" }) {
  useEffect(() => {
    if (!open) return;
    const esc = (e) => e.key === "Escape" && onClose?.();
    document.addEventListener("keydown", esc);
    return () => document.removeEventListener("keydown", esc);
  }, [open, onClose]);

  if (!open) return null;

  const width = size === "lg" ? "max-w-2xl" : "max-w-lg";

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-[rgba(26,46,34,0.35)] backdrop-blur-sm animate-fadeup"
         onClick={onClose} data-testid="modal-overlay">
      <div className={`bg-[var(--bg-card)] w-full ${width} rounded-2xl border border-[var(--border-default)] shadow-2xl`}
           onClick={(e) => e.stopPropagation()}>
        <div className="px-6 py-4 border-b border-[var(--border-default)] flex items-center justify-between">
          <h3 className="text-lg font-medium tracking-tight" style={{fontFamily:'var(--font-heading)'}}>{title}</h3>
          <button className="btn-danger-ghost" onClick={onClose} data-testid="modal-close-btn"><X size={18}/></button>
        </div>
        <div className="p-6">{children}</div>
      </div>
    </div>
  );
}
